import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-hospital-option-card-mobile',
  imports: [CommonModule, MatCardModule, MatButtonModule, TranslateModule],
  templateUrl: './hospital-option-card.component.html',
  styleUrl: './hospital-option-card.component.css'
})
export class HospitalOptionCardComponent implements OnInit {
  @Input() name!: string;
  @Input() photo!: string;
  @Input() phone!: string;
  @Input() address: string | null = null;
  @Input() city: string | null = null;
  @Input() state: string | null = null;
  @Input() zip: string | null = null;
  @Input() distance!: number;
  @Input() imageUrl!: string;
  @Input() locale: string | null = null;
  @Input() latitude: number | null = null;
  @Input() longitude: number | null = null;
  @Input() locationDirection: string | null = null;

  // Template properties
  public milesAwayText: string = 'MILES_AWAY';
  public getDirectionsText: string = 'GET_DIRECTIONS';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem("locale") || 'en-US'); // Default to 'en-US' if no locale is provided
  }
  
  ngOnInit(): void {
    this.translate.get('GET_DIRECTIONS').subscribe((translated: string) => {
      this.getDirectionsText = translated;
    });
    console.log(this.name)
  }

  getDirection() {  
    var deepLink = '';

    // Generate Google Maps deep link using coordinates or address
    if (this.locationDirection) {
      deepLink = this.locationDirection;
    } 
    else if (this.latitude && this.longitude) {
      // Use coordinates for more precise navigation with hospital name
      deepLink = `https://www.google.com/maps/dir/?api=1&destination=${this.latitude},${this.longitude}&destination_place_id=${encodeURIComponent(this.name)}`;
      
      // Add additional parameters if available
      if (this.photo) {
        deepLink += `&photo=${encodeURIComponent(this.photo)}`;
      }
    } 
    else if (this.address) {
      // Fallback to address-based search with hospital name
      const fullAddress = [this.name, this.address, this.city, this.state, this.zip]
        .filter(part => part) // Remove null/empty parts
        .join(', ');
      deepLink = environment.web_google_map + encodeURIComponent(fullAddress);
      
      // Add photo parameter if available
      if (this.photo) {
        deepLink += `&photo=${encodeURIComponent(this.photo)}`;
      }
    } 
    else {
      console.error('No location data available for directions');
      return;
    }

    this.monitoringService.logEvent('Get Direction', { feature: 'prelogin', subfeature: 'Hospital', platform: 'mobile-plus'}); 
   
    console.log("Get Direction clicked (Hospital)");
    console.log(deepLink);
      
    // Open in new tab
    window.open(deepLink, '_blank');
  }

  callNow() {
    var deepLink = `tel:${this.phone}`;
    this.monitoringService.logEvent('Call', { feature: 'prelogin', subfeature: 'Hospital', platform: 'mobile-plus' }); 
   
    console.log("Call clicked (Hospital)");
    console.log(deepLink);
      
    window.location.href = deepLink;
  }
}